<template>
  <div class="products">
    <products-cards />
    <mf-info-card variant="info" :v-html="infoCardHtml" class="mb-3 mt-0" />
    <mf-card-container v-if="isFranchisee" v-model="searchFranchise" class="mb-4" title="Ofertas da rede" placeholder="Buscar produto ou grupo" use-search>
      <template v-slot:headers>
        <mf-status-filter v-if="itemsFilter.length > 1" :items="itemsFilter" @input="getFilterResultFranchisee" />
        <headers-data-table-settings
          :headers.sync="headersFranchise"
          :default-headers="getDefaultHeadersOptions()"
          headers-settings-name="mobile-offers-products-franchise-headers-configs"
        />
      </template>
      <template v-slot:filters>
        <products-filters
          :filters="filtersFranchise"
          :options="optionsFranchise"
          filter-type="franchise"
          @update-data="setFranchiseData"
          @clear-filters="clearFilters"
        />
      </template>

      <offers-products-table
        :headers="computedHeadersFranchise"
        :loading="paginationLoadingFranchise"
        :server-items-length="salesProductsFranchise.records"
        :items="salesProductsFranchise.salesProducts"
        :options.sync="optionsFranchise"
        :items-per-page="5"
        is-franchise
        @open-edit-shop-dialog="openEditUnitDialog"
      />
    </mf-card-container>

    <mf-card-container v-model="search" title="Minhas ofertas" placeholder="Buscar produto ou grupo" use-search>
      <template v-slot:headers>
        <div class="d-flex flex-row align-center">
          <mf-status-filter v-if="itemsFilter.length > 1" :items="itemsFilter" @input="getFilterResult" />
          <headers-data-table-settings
            :headers.sync="headers"
            :default-headers="getDefaultHeadersOptions()"
            headers-settings-name="mobile-offers-products-headers-configs"
          />
        </div>
      </template>
      <template v-slot:filters>
        <products-filters :filters="filters" :options="options" @update-data="setData" @clear-filters="clearFilters" />
      </template>

      <offers-products-table
        :headers="computedHeaders"
        :loading="paginationLoading"
        :server-items-length="salesProducts.records"
        :items="salesProducts.salesProducts"
        :options.sync="options"
        my-offers-table
        @open-edit-shop-dialog="openEditUnitDialog"
        @edit-group="editGroup"
        @open-edit-dialog="openDialog"
      />
    </mf-card-container>
    <mf-select-units-dialog
      ref="saleUnitSelection"
      hidden-template
      label="Lojas"
      :selected-units.sync="selectedSaleUnits"
      :filter-to-units="selectedSaleUnitsToFilter"
      :tag-list="tagList"
      :group-list="unitsGroups"
      :units="allUnits"
      @change="updateSaleAppUnits"
    />
    <product-edit-dialog
      v-if="dialogEditProduct"
      :dialog.sync="dialogEditProduct"
      :product-data="selectedProduct"
      :categories="categories"
      :categories-types="categoriesFilter"
      @updated="setData"
    />
    <dialog-upsert-products-group
      v-if="dialogUpsertGroup"
      :dialog.sync="dialogUpsertGroup"
      :group.sync="selectedGroup"
      :is-new="isNew"
      :categories-types="categoriesFilter"
      :categories="categories"
      app-sales
      @close="setData"
    />
  </div>
</template>

<script>
import orderBy from 'lodash/orderBy'
import cloneDeep from 'lodash/cloneDeep'
import { PRODUCT_CATEGORIES, PRODUCT_CATEGORIES_FINAL_CONSUMER } from '@/modules/produtos/gerenciamento-produtos/graphql'
import { SALE_PRODUCTS, UPDATE_SALE_APP_UNITS, UPDATE_FRANCHISE_SALE_APP_UNITS, GET_PRODUCT } from '../../graphql'
import { getProductTypeLabel, getProductFormatTypeLabel } from '@/modules/mobile/ofertas/helpers/productType.js'
import { mapGetters } from 'vuex'
import { getStatusLabel } from '@/config/helpers.js'

export default {
  components: {
    ProductEditDialog: () => import('@/modules/produtos/gerenciamento-produtos/views/pages/createEditProduct/ProductEditDialog.vue'),
    ProductsCards: () => import('../components/ProductsCards.vue'),
    ProductsFilters: () => import('../components/ProductsFilters.vue'),
    DialogUpsertProductsGroup: () => import('@/modules/produtos/gerenciamento-produtos/views/pages/DialogUpsertProductsGroup.vue'),
    HeadersDataTableSettings: () => import('@/components/HeadersDataTableSettings.vue'),
    OffersProductsTable: () => import('../components/OffersProductsTable.vue'),
  },
  data: () => ({
    timeout: {},
    dialogEditProduct: false,
    paginationLoading: false,
    paginationLoadingFranchise: false,
    search: '',
    searchFranchise: '',
    selectedProduct: {},
    selectedGroup: {},
    options: {},
    optionsFranchise: {},
    filters: {
      selectedUnits: [],
      images: 'Todos',
    },
    filtersFranchise: {
      selectedUnits: [],
      images: 'Todos',
    },
    salesProducts: [],
    salesProductsFranchise: [],
    selectedSaleUnits: [],
    selectedSaleUnitsToFilter: [],
    selectedSale: {},
    loading: false,
    dialogUpsertGroup: false,
    isNew: false,
    headers: [],
    headersFranchise: [],
    isEditingFranchiseSaleUnits: false,
    statusToSearch: [],
    statusToSearchFranchisee: [],
    itemsFilter: [
      { label: getStatusLabel('ACTIVE').text, value: 'ACTIVE', color: getStatusLabel('ACTIVE').color, active: true },
      { label: getStatusLabel('SCHEDULED').text, value: 'SCHEDULED', color: getStatusLabel('SCHEDULED').color, active: true },
    ],
  }),
  computed: {
    ...mapGetters(['tagList', 'unitsGroups']),
    infoCardHtml() {
      return '<span style="color: #004D99">As alterações realizadas nas ofertas <b>podem levar até 10 minutos</b> para serem propagadas em todos os dispositivos devido ao sistema de cache implementado para otimizar o desempenho do aplicativo.</span>'
    },
    allUnits() {
      return this.$store.getters.units
    },
    computedHeaders() {
      const headers = this.headers.filter((header) => header.isActive)
      return headers.map((header) => {
        return {
          ...header,
          width: header.width,
        }
      })
    },
    computedHeadersFranchise() {
      const headers = this.headersFranchise.filter((header) => header.isActive)
      return headers.map((header) => {
        return {
          ...header,
          width: header.width,
        }
      })
    },
    defaultHeaders() {
      let headers = [
        {
          text: 'Imagem',
          value: 'image_url',
          width: '75px',
          sortable: false,
          isActive: true,
          isRequired: false,
          isDefault: true,
        },
        {
          text: 'Código',
          value: 'sku',
          width: '120px',
          sortable: false,
          isActive: true,
          isRequired: true,
          isDefault: true,
        },
        {
          text: 'Nome em exibição',
          value: 'name',
          width: '250px',
          isActive: true,
          isRequired: false,
          isDefault: true,
        },
        {
          text: 'Lojas',
          sortable: false,
          width: '90px',
          value: 'units',
          isActive: true,
          isRequired: false,
          isDefault: true,
        },
        {
          text: 'Modelo',
          value: 'activatable',
          width: '70px',
          isActive: true,
          isRequired: false,
          isDefault: true,
        },
        {
          text: 'Tipo',
          value: 'personalized',
          width: '90px',
          isActive: true,
          isRequired: false,
          isDefault: true,
        },
        {
          text: 'Formato',
          value: 'type',
          width: '130px',
          isActive: true,
          isRequired: false,
          isDefault: true,
        },
        {
          text: 'Validade',
          value: 'dates',
          width: '110px',
          isActive: true,
          isRequired: false,
          isDefault: true,
        },
        ...(this.hasCashback
          ? [
              {
                text: 'Cashback',
                value: 'cashback_absolute',
                width: '100px',
                isActive: true,
                isRequired: false,
                isDefault: true,
              },
            ]
          : []),
        ...(this.hasPoints
          ? [
              {
                text: 'Pontos extras',
                value: 'additional_points_rate',
                width: '110px',
                isActive: true,
                isRequired: false,
                isDefault: true,
              },
            ]
          : []),
        {
          text: 'Desconto',
          value: 'discount',
          width: '150px',
          sortable: false,
          isActive: true,
          isRequired: false,
          isDefault: true,
        },
        {
          text: '',
          sortable: false,
          value: 'action',
          width: '40px',
          isActive: true,
          isRequired: false,
          isDefault: true,
        },
      ]
      return headers
    },
    isFranchise() {
      // rede
      if (!this.$getLoggedUser().is_franchise) return false
      return this.$getLoggedUser().is_franchise
    },
    isFranchisee() {
      // franquia
      if (!this.$getLoggedUser().is_franchisee) return false
      return this.$getLoggedUser().is_franchisee
    },
    hasCashback() {
      return this.$getAllowedModules()['cashback']
    },
    hasPoints() {
      return this.$getAllowedModules()['points']
    },
  },
  apollo: {
    categories: {
      query: PRODUCT_CATEGORIES,
      update({ productCategories }) {
        const categories = orderBy(productCategories, 'name')
        return categories
      },
    },
    categoriesFilter: {
      query: PRODUCT_CATEGORIES_FINAL_CONSUMER,
      variables() {
        return {
          search: '',
        }
      },
      update({ categoriesFinalConsumer }) {
        const categories = orderBy(categoriesFinalConsumer, 'name')
        return categories
      },
    },
  },
  watch: {
    statusToSearch() {
      this.setData()
    },
    statusToSearchFranchisee() {
      this.setFranchiseData()
    },
    options() {
      this.setData()
    },
    optionsFranchise() {
      this.setFranchiseData()
    },
    search(newValue) {
      this.filterBySearch(newValue)
    },
    searchFranchise(newValue) {
      this.filterBySearchFranchise(newValue)
    },
  },
  beforeMount() {
    this.statusToSearch = this.itemsFilter.map((item) => item.value)
    this.statusToSearchFranchisee = this.itemsFilter.map((item) => item.value)
  },
  async mounted() {
    if (!this.headers.length) this.headers = cloneDeep(this.defaultHeaders)
    if (!this.headersFranchise.length && this.isFranchisee) this.headersFranchise = cloneDeep(this.defaultHeaders)
    this.setData()

    if (this.isFranchisee) this.setFranchiseData()
  },
  methods: {
    getProductTypeLabel,
    getProductFormatTypeLabel,
    removeZerosPrefix(str) {
      return str.replace(/^0+/, '')
    },
    getDefaultHeadersOptions() {
      return cloneDeep(this.defaultHeaders)
    },
    getFilterResult(value) {
      this.statusToSearch = value.length ? value : this.itemsFilter.map((item) => item.value)
    },
    getFilterResultFranchisee(value) {
      this.statusToSearchFranchisee = value.length ? value : this.itemsFilter.map((item) => item.value)
    },
    async updateSaleAppUnits() {
      const salesProducts = this.isEditingFranchiseSaleUnits ? this.salesProductsFranchise.salesProducts : this.salesProducts.salesProducts
      const index = salesProducts.findIndex((item) => item._id === this.selectedSale._id)
      this.loading = true
      salesProducts[index].loading = true
      const updateSalesMutation = this.isEditingFranchiseSaleUnits ? UPDATE_FRANCHISE_SALE_APP_UNITS : UPDATE_SALE_APP_UNITS
      try {
        await this.$apollo.mutate({
          mutation: updateSalesMutation,
          variables: {
            _id: this.selectedSale._id,
            units: this.selectedSaleUnits,
          },
        })
        this.$snackbar({ message: 'Oferta atualizada', snackbarColor: 'success' })
      } catch {
        this.$snackbar({ message: 'Erro ao editar oferta', snackbarColor: 'error' })
      } finally {
        salesProducts[index].loading = false
        this.loading = false
        if (this.isEditingFranchiseSaleUnits) {
          this.setFranchiseData()
        } else {
          this.setData()
        }
      }
    },
    openEditUnitDialog(sale, isFranchise = false) {
      this.isEditingFranchiseSaleUnits = isFranchise
      const salesProducts = isFranchise ? this.salesProductsFranchise.salesProducts : this.salesProducts.salesProducts
      const index = salesProducts.findIndex((item) => item._id === sale._id)
      salesProducts[index].loading = true
      this.selectedSaleUnits = sale.app_units.map((unit) => unit.id_erp)
      this.selectedSaleUnitsToFilter = sale.units.map((unit) => unit.id_erp)
      this.selectedSale = sale
      setTimeout(() => {
        salesProducts[index].loading = false
        this.$refs.saleUnitSelection.dialog = true
      }, 300)
    },
    searchProduct(sale) {
      const { sku, eans } = sale
      const formattedEans = eans.filter((ean) => ean !== '0')
      return this.$apollo.query({
        query: GET_PRODUCT,
        variables: {
          filter: {
            ...(this.isFranchise && { eans: formattedEans }),
            ...(!this.isFranchise && { legacySku: sku }),
          },
        },
        context: {
          uri: this.$microservicesUrls['fedGateway'],
        },
        fetchPolicy: 'no-cache',
      })
    },
    openDialog(sale) {
      this.openEditProductDialog(sale)
    },
    async openEditProductDialog(sale) {
      const index = this.salesProducts.salesProducts.findIndex((item) => item._id === sale._id)
      this.salesProducts.salesProducts[index].loading = true

      try {
        const {
          data: { findProduct },
        } = await this.searchProduct(sale)
        this.selectedProduct = findProduct
        this.dialogEditProduct = true
      } catch (error) {
        this.$snackbar({ message: 'Erro ao buscar produto', snackbarColor: 'error' })
      } finally {
        this.salesProducts.salesProducts[index].loading = false
      }
    },
    editGroup(group) {
      this.isNew = false
      this.selectedGroup = group
      this.dialogUpsertGroup = true
    },
    filterBySearch(query) {
      clearTimeout(this.timeout)
      this.paginationLoading = true
      this.timeout = setTimeout(() => {
        this.options.page = 1
        this.setData()
      }, 1000)
    },
    filterBySearchFranchise(query) {
      clearTimeout(this.timeout)
      this.paginationLoadingFranchise = true
      this.timeout = setTimeout(() => {
        this.options.page = 1
        this.setFranchiseData()
      }, 1000)
    },
    getData(variables) {
      try {
        return this.$apollo.query({
          query: SALE_PRODUCTS,
          variables,
          fetchPolicy: 'no-cache',
        })
      } catch (error) {
        this.$snackbar({ message: 'Erro ao buscar produtos', snackbarColor: 'error' })
      }
    },
    async setData() {
      const search = this.isFranchise ? this.removeZerosPrefix(this.search) : this.search

      const newFilters = {
        status: this.statusToSearch,
        units: this.filters.selectedUnits && this.filters.selectedUnits.length > 0 ? this.filters.selectedUnits : undefined,
        page: this.options.page || 1,
        pageSize: this.options.itemsPerPage || 10,
        search,
        sort: this.options.sortBy,

        sort_direction: this.options.sortDesc ? this.options.sortDesc.map((val) => (val ? 'DESC' : 'ASC')) : ['DESC'],
      }

      if (this.filters.images !== 'Todos') {
        newFilters.has_image = this.filters.images
      }

      this.paginationLoading = true

      const {
        data: { salesProducts },
      } = await this.getData(newFilters)

      salesProducts.salesProducts.forEach((item) => {
        Object.assign(item, { loading: false })
      })

      this.salesProducts = salesProducts
      this.paginationLoading = false
    },
    async setFranchiseData() {
      const newFilters = {
        status: this.statusToSearchFranchisee,
        units: this.filtersFranchise.selectedUnits && this.filtersFranchise.selectedUnits.length > 0 ? this.filtersFranchise.selectedUnits : undefined,
        page: this.optionsFranchise.page || 1,
        pageSize: this.optionsFranchise.itemsPerPage || 5,
        search: this.searchFranchise,
        sort: this.optionsFranchise.sortBy,
        sort_direction: this.optionsFranchise.sortDesc ? this.optionsFranchise.sortDesc.map((val) => (val ? 'DESC' : 'ASC')) : ['DESC'],
        franchise: true,
        only_franchise: true,
      }

      if (this.filtersFranchise.images !== 'Todos') {
        newFilters.has_image = this.filtersFranchise.images
      }

      this.paginationLoadingFranchise = true

      const {
        data: { salesProducts },
      } = await this.getData(newFilters)

      salesProducts.salesProducts.forEach((item) => {
        Object.assign(item, { loading: false })
      })
      this.salesProductsFranchise = salesProducts
      this.paginationLoadingFranchise = false
    },
    clearFilters(filterType) {
      if (filterType === 'franchise') {
        this.filtersFranchise = {
          selectedUnits: [],
          images: 'Todos',
        }
        this.setFranchiseData()
        return
      }
      this.filters = {
        selectedUnits: [],
        images: 'Todos',
      }
      this.setData()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-data-table {
  overflow-x: auto;
}

::v-deep .table-header-actions {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
}
</style>
